/* HUSHLY — pilote de la scene epinglee. Conteneur haut + enfant sticky, progression 0 a 1. */
(function(){
  var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(v){ return v < 0 ? 0 : v > 1 ? 1 : v; }
  /* rampe : 0 avant a, 1 apres b, lisse entre les deux */
  function ramp(p, a, b){ var t = clamp((p - a) / (b - a)); return t * t * (3 - 2 * t); }

  function boot(scene){
    if (scene.dataset.hpReady === '1') return;
    scene.dataset.hpReady = '1';
    var notes = [].slice.call(scene.querySelectorAll('.hp-note'));
    var dots   = [].slice.call(scene.querySelectorAll('.hp-dot'));
    var groups = [].slice.call(scene.querySelectorAll('.hp-leadg'));
    var svg    = scene.querySelector('.hp-leads');
    var box    = scene.querySelector('.hp-scenebox');

    /* Le trace se mesure, il ne se calcule pas en pourcentages : il part du bord du bloc
       tourne vers la pastille, a hauteur du titre, avec un coude court cote texte. */
    var ELBOW = 20, GAP = 14;
    function measure(){
      if (!svg || !box || !groups.length) return;
      var np = notes.map(function(n){ return n.style.getPropertyValue('--np'); });
      var dp = dots.map(function(d){ return d.style.getPropertyValue('--dp'); });
      notes.forEach(function(n){ n.style.setProperty('--np', 1); });
      dots.forEach(function(d){ d.style.setProperty('--dp', 1); });
      var b = box.getBoundingClientRect();
      svg.setAttribute('viewBox', '0 0 ' + Math.round(b.width) + ' ' + Math.round(b.height));
      for (var i = 0; i < groups.length; i++){
        var note = notes[i], dot = dots[i];
        if (!note || !dot) continue;
        var nb = note.getBoundingClientRect();
        var t  = note.querySelector('b');
        var tb = t ? t.getBoundingClientRect() : nb;
        var db = dot.getBoundingClientRect();
        var cx = db.left + db.width / 2, cy = db.top + db.height / 2;
        var x2 = cx - b.left, y2 = cy - b.top;
        var x0, y0, x1, y1;
        if (cx > nb.right){
          x0 = nb.right + GAP - b.left; y0 = (tb.top + tb.height * 0.62) - b.top;
          x1 = x0 + ELBOW; y1 = y0;
        } else if (cx < nb.left){
          x0 = nb.left - GAP - b.left;  y0 = (tb.top + tb.height * 0.62) - b.top;
          x1 = x0 - ELBOW; y1 = y0;
        } else {
          /* la pastille est a l'aplomb du bloc de texte : c'est le cas du mobile, ou la
             legende occupe toute la largeur sous le coussin. On part alors du numero
             plutot que du milieu du bloc, pour que l'oeil relie le chiffre a son point. */
          var num = note.querySelector('.hp-note__num');
          var anchor = (num && nb.width > b.width * 0.7) ? num.getBoundingClientRect() : null;
          if (anchor){
            /* Mobile : la legende occupe toute la largeur sous le coussin. Une diagonale
               du numero jusqu'au point traverserait tout le produit et frolerait les
               autres pastilles. On trace donc une equerre : un segment horizontal juste
               au-dessus du texte, puis une montee verticale a l'aplomb du point. */
            x0 = (anchor.left + anchor.width / 2) - b.left;
            y0 = nb.top - GAP - b.top;
            x1 = x2; y1 = y0;
          } else {
            x0 = (nb.left + nb.width / 2) - b.left;
            y0 = (cy < nb.top ? nb.top - GAP : nb.bottom + GAP) - b.top;
            x1 = x0; y1 = y0 + (cy < nb.top ? -ELBOW : ELBOW);
          }
        }
        var d = 'M ' + x0.toFixed(1) + ',' + y0.toFixed(1) +
                ' L ' + x1.toFixed(1) + ',' + y1.toFixed(1) +
                ' L ' + x2.toFixed(1) + ',' + y2.toFixed(1);
        var paths = groups[i].querySelectorAll('path');
        for (var k = 0; k < paths.length; k++) paths[k].setAttribute('d', d);
        groups[i].style.setProperty('--len',
          Math.ceil(Math.sqrt((x1-x0)*(x1-x0) + (y1-y0)*(y1-y0))
                  + Math.sqrt((x2-x1)*(x2-x1) + (y2-y1)*(y2-y1)) + 6));
      }
      notes.forEach(function(n,k){ if (np[k]==='') n.style.removeProperty('--np'); else n.style.setProperty('--np', np[k]); });
      dots.forEach(function(d,k){ if (dp[k]==='') d.style.removeProperty('--dp'); else d.style.setProperty('--dp', dp[k]); });
    }
    addEventListener('resize', measure);
    measure();


    var N = notes.length;
    if (REDUCE){
      scene.style.setProperty('--a1',1); scene.style.setProperty('--a2',1);
      scene.style.setProperty('--a3',1); scene.style.setProperty('--spinp',0);
      notes.forEach(function(n){ n.style.setProperty('--np',1); n.style.setProperty('--ns',1); });
      dots.forEach(function(n){ n.style.setProperty('--dp',1); });
      groups.forEach(function(n){ n.style.setProperty('--np',1); });
      measure();
      return;
    }

    /* Le decoupage temporel differe sur telephone. En desktop l'introduction peut
       respirer, les legendes sont cote a cote et se lisent d'un coup d'oeil. En mobile
       elles se relaient dans un seul emplacement : l'attente du debut y paraissait
       interminable et les trois se succedaient ensuite trop vite. On raccourcit donc
       l'introduction de moitie et on double le temps de lecture de chaque legende. */
    var MOB = window.matchMedia ? matchMedia('(max-width:749px)') : null;
    function timing(){
      return (MOB && MOB.matches)
        ? {a1:[0.03,0.12], spin:[0.05,0.25], a2:[0.14,0.24],
           s0:0.20, step:0.19, dur:0.10, outAt:0.19, outLen:0.05, dotAt:0.08, dotLen:0.04,
           a3:[0.80,0.92]}
        : {a1:[0.16,0.30], spin:[0.22,0.52], a2:[0.34,0.50],
           s0:0.40, step:0.09, dur:0.12, outAt:0.13, outLen:0.06, dotAt:0.10, dotLen:0.04,
           a3:[0.74,0.88]};
    }
    var TM = timing();
    addEventListener('resize', function(){ TM = timing(); });

    var HOLD = parseFloat(scene.dataset.hold || '12') / 100;
    var END = 1 / (1 + HOLD);
    var ticking = false;

    /* requestAnimationFrame ne se declenche pas dans un onglet masque : on retombe sur un appel direct */
    function schedule(){
      if (ticking) return;
      ticking = true;
      if (document.hidden) { frame(); } else { requestAnimationFrame(frame); }
    }
    addEventListener('scroll', schedule, {passive:true});
    addEventListener('resize', schedule);
    /* une frame demandee avant que l'onglet passe en fond ne se declenche jamais :
       sans ce reset le verrou reste pris et le defilement ne pilote plus rien */
    document.addEventListener('visibilitychange', function(){ ticking = false; schedule(); });

    function frame(){
      ticking = false;
      var rect = scene.getBoundingClientRect();
      /* hors champ : on ne calcule rien */
      if (rect.bottom < -300 || rect.top > innerHeight + 300) return;
      var total = scene.offsetHeight - innerHeight; if (total <= 0) total = 1;
      var raw = clamp(-rect.top / total);
      var p = clamp(raw / END);

      /* acte 1 : le coussin attend avec le CTA, puis le texte s'efface */
      scene.style.setProperty('--a1', 1 - ramp(p, TM.a1[0], TM.a1[1]));
      /* la rotation : la CSS fait le fondu et l'ombre a partir de cette seule valeur */
      scene.style.setProperty('--spinp', ramp(p, TM.spin[0], TM.spin[1]));
      /* acte 2 : les fleches se tracent */
      var a2 = ramp(p, TM.a2[0], TM.a2[1]);
      scene.style.setProperty('--a2', a2);
      /* chaque benefice arrive a son tour : l'etiquette, sa ligne et son point
         partagent la meme valeur, donc le trait n'arrive jamais avant sa cible */
      for (var i = 0; i < N; i++){
        var s = TM.s0 + i * TM.step;
        var v = ramp(p, s, s + TM.dur);
        notes[i].style.setProperty('--np', v);
        /* --ns : la meme legende, mais avec une FIN. Sur mobile elles partagent un seul
           emplacement, donc chacune doit s'effacer pour laisser la place a la suivante. */
        /* la derniere legende ne s'efface pas : entre sa sortie et l'arrivee de la carte
           il restait un passage ou l'ecran ne montrait plus rien. Elle tient jusqu'au bout. */
        var vs = (i === N - 1)
          ? v.toFixed(3)
          : (v * (1 - ramp(p, s + TM.outAt, s + TM.outAt + TM.outLen))).toFixed(3);
        notes[i].style.setProperty('--ns', vs);
        if (groups[i]) {
          groups[i].style.setProperty('--np', v);
          /* en mobile les trois legendes partagent un seul emplacement : le trait doit
             s'effacer avec la sienne, donc il suit --ns et non --np */
          groups[i].style.setProperty('--ns', vs);
        }
        /* le point se pose APRES l'arrivee du trait, sinon il flotte seul pendant tout le scroll */
        if (dots[i]) dots[i].style.setProperty('--dp', ramp(p, s + TM.dotAt, s + TM.dotAt + TM.dotLen));
      }
      /* acte 3 : le badge */
      scene.style.setProperty('--a3', ramp(p, TM.a3[0], TM.a3[1]));
      scene.style.setProperty('--p', p.toFixed(4));
    }
    schedule();
  }

  function init(root){
    var nodes = (root || document).querySelectorAll('.hp-scene');
    /* on attend les polices, sinon la hauteur des lignes bouge apres coup */
    (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve())
      .then(function(){ [].forEach.call(nodes, boot); });
  }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', function(){ init(); }, {once:true});
  else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

